import * as React from "react"

const SvgComponent = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  const w = 140
  const h = 140
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter1_di_4131_322278)">
        <rect x="20" y="20" width="100" height="100" rx="50" fill="#F5F5F5" />
      </g>
      <g filter="url(#filter2_i_4131_322278)">
        <rect x="29" y="29" width="82" height="82" rx="41" fill="#F5F5F5" />
        <g filter="url(#filter3_i_4131_322278)">
          <path
            d="M76.3611 64.6406C77.6195 65.8994 78.4764 67.5031 78.8234 69.2488C79.1704 70.9946 78.992 72.804 78.3107 74.4484C77.6295 76.0927 76.4759 77.4982 74.9959 78.487C73.5159 79.4758 71.776 80.0035 69.9961 80.0035C68.2162 80.0035 66.4762 79.4758 64.9963 78.487C63.5163 77.4982 62.3627 76.0927 61.6815 74.4484C61.0002 72.804 60.8218 70.9946 61.1688 69.2488C61.5158 67.5031 62.3727 65.8994 63.6311 64.6406"
            stroke="#910A2D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70 60V70"
            stroke="#910A2D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter1_di_4131_322278"
          x="10"
          y="10"
          width="120"
          height="124"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4131_322278"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4131_322278"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-10" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_4131_322278"
          />
        </filter>
        <filter
          id="filter2_i_4131_322278"
          x="29"
          y="29"
          width="82"
          height="92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4131_322278"
          />
        </filter>
        <filter
          id="filter3_i_4131_322278"
          x="58"
          y="58"
          width="24"
          height="25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.75" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.9875 0 0 0 0 0.164583 0 0 0 0 0.377932 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4131_322278"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgComponent
